import { render, staticRenderFns } from "./FornecedoresDialogBuscar.vue?vue&type=template&id=6ca759ba&"
import script from "./FornecedoresDialogBuscar.vue?vue&type=script&lang=ts&"
export * from "./FornecedoresDialogBuscar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports